<div class="subject-match-dialog">
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Subject Matches ({{subjectCount}})</span>
            <!-- <button mat-button class="mat-icon-button white-fg"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button> -->
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0" fusePerfectScrollbar>

        <div id="tpSubject" *ngIf="tpSubject" class="card">
            <div class="card-header">
                <h3>New {{tpSubject?.Type}} - {{tpSubject?.Reference}}</h3>
            </div>
            <div class="card-main">
                <div *ngFor="let item of tpSubjectDetails" class="px-16 py-4" style="display: flex;">
                    <div class="key">{{item.key}}</div>
                    <div class="value">{{item.value}}</div>
                </div>
            </div>
        </div>

        <div id="existingSubject" *ngIf="existingSubject" class="card">
            <div class="card-header" set-color [backgroundColor]="existingSubject?.subjectType.color">
                <h3>Existing {{existingSubject?.subjectType.name}} - {{existingSubject?.summary}}</h3>
            </div>
            <div class="card-main">
                <subject-card *ngIf="existingSubject" [autoSize]="true" [subject]='existingSubject'></subject-card>
                <mat-divider class="px-16 my-16 w-100-p mat-divider mat-divider-horizontal" role="separator"
                    aria-orientation="horizontal"></mat-divider>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 pr-4">Linked Subjects</div>
                </div>
                <linked-subjects-list [subject]='existingSubject' style="max-height: 200px; overflow-y: scroll;">
                </linked-subjects-list>
            </div>
        </div>

        <div id="existingSubjectList" *ngIf="matchingSubjects && (matchingSubjects.length !== 0)" class="card">
            <div class="card-header">
                <h3>Existing Subjects ({{subjectCount}})</h3>
            </div>
            <div class="card-main" style="padding:0px;max-height:400px">
                <subject-list-preview [subjects]="matchingSubjects" [autoSelect]="true" (onSelect)="select($event)">
                </subject-list-preview>
            </div>
        </div>

        <div id="newSubject" *ngIf="newSubject" class="card">
            <div class="card-header" set-color [backgroundColor]="newSubject?.subjectType.color">
                <h3>New {{newSubject?.subjectType.name}} - {{newSubject?.summary}}</h3>
            </div>
            <div class="card-main">
                <subject-card *ngIf="newSubject" [autoSize]="true" [subject]='newSubject'></subject-card>
            </div>
        </div>

    </div>
    <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button id="btnAdd" mat-raised-button type="submit" (click)="add()" class="mat-accent" aria-label="ADD">
                ADD NEW
            </button>
            <button id="btnDiscard" mat-raised-button type="submit" (click)="discard()" class="mat-warn"
                aria-label="DISCARD" [setFocus]="true">
                USE EXISTING
            </button>
            <button id="btnCancel" mat-raised-button type="submit" (click)="cancel()" class="mat-accent"
                aria-label="CANCEL">
                CANCEL
            </button>
        </div>
    </div>
</div>